// extracted by mini-css-extract-plugin
export default {"image":"dWPrc4"};